// extracted by mini-css-extract-plugin
export default {"homeAdvertList":"c-c_cP","homeAdvertList__cardListContainer":"c-c_cQ","homeAdvertList__loadMoreContainer":"c-c_cR"};